import React from "react";
import {
  FaLaptopCode,
  FaCoins,
  FaFileContract,
  FaWallet,
} from "react-icons/fa";

function ProcessCard({ icon: Icon, title, description }) {
  return (
    <div className="process-style-three-item fade-up-anim">
      <div className="icon" style={{ fontSize: "40px", color: "#fff" }}>
        <Icon />
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
}

function SolanaDApp() {
  const processes = [
    {
      title: "Solana DApp Development",
      description:
        "We create powerful decentralized applications on Solana that support high-speed transactions and low fees, providing an efficient, scalable user experience.",
      icon: FaLaptopCode,
    },
    {
      title: "Solana DeFi Development",
      description:
        "Xeer Technology builds innovative DeFi platforms on Solana, including staking platforms, lending protocols, and yield farming solutions that offer reliable, cost-effective services.",
      icon: FaCoins,
    },
    {
      title: "Smart Contract Development",
      description:
        "Our developers write secure and high-performance smart contracts in Rust for the Solana network, ensuring efficiency and adherence to Solana's standards.",
      icon: FaFileContract,
    },
    {
      title: "NFT Marketplace Development",
      description:
        "Create engaging NFT marketplaces on Solana with Xeer, designed for fast, affordable trading, minting, and management of NFTs with user-friendly interfaces.",
      icon: FaCoins,
    },
    {
      title: "Solana Wallet Development",
      description:
        "We develop robust crypto wallets tailored for Solana, allowing users to securely store, send, and receive SOL and other tokens.",
      icon: FaWallet,
    },
    {
      title: "Token Development (SPL Tokens)",
      description:
        "Xeer Technology specializes in SPL token creation on Solana, helping you develop and launch tokens for diverse use cases like DeFi, NFTs, and more.",
      icon: FaCoins,
    },
    {
      title: "Blockchain Integration",
      description:
        "We assist businesses in integrating Solana into their existing systems, making it easier to adopt Solana's blockchain infrastructure for enhanced performance.",
      icon: FaLaptopCode,
    },
  ];

  return (
    <div
      className="process-style-three-area default-padding bg-dark text-light bg-cover"
      style={{
        backgroundImage:
          "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-22.jpg)",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="site-heading">
              <h4 className="sub-title">How it works</h4>
              <h2 className="title split-text-right split-text-in-right">
                Xeer's Solana Blockchain Development Services
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-11 offset-lg-1">
            <div className="process-style-four-items">
              {processes.map((process, idx) => (
                <ProcessCard key={idx} {...process} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SolanaDApp;
